import { render, staticRenderFns } from "./IntegracaoRndsTabela.vue?vue&type=template&id=5d9b6ef6&scoped=true&"
import script from "./IntegracaoRndsTabela.vue?vue&type=script&lang=js&"
export * from "./IntegracaoRndsTabela.vue?vue&type=script&lang=js&"
import style0 from "./IntegracaoRndsTabela.vue?vue&type=style&index=0&id=5d9b6ef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9b6ef6",
  null
  
)

export default component.exports